import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/theme';
import './App.css';
import { Signin } from './pages/auth/Signin';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ResetPassword } from './pages/auth/ResetPassword';
import { Dashboard } from './pages/dashboard';
import { Users } from './pages/users';
import { Products } from './pages/products';
import { Templates } from './pages/templates';
import { Clients } from './pages/clients';
import { UploadTags } from './pages/upload-tags';
import { Bars } from './pages/bars';
import { Categories } from './pages/categories';
import { Error404 } from './pages/errors/Error404';
import { AuthProvider } from './assets/contexts/AuthContext';
import { Sectors } from './pages/sectors';
import { Design } from './pages/templates/Design';
import { DesignPreview } from './pages/templates/DesignPreview';
import { Tags } from './pages/tags';
import { Pages } from './pages/Pages';
import { ClientBars } from './pages/client-bars';


function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users/*" element={<Users />} />
            <Route path="/products/*" element={<Products />} />
            <Route path="/templates/*" element={<Templates />} />
            <Route path="/templates/:template_id/design" element={<Design />} />
            <Route path="/templates/:template_id/design-preview" element={<DesignPreview />} />
            <Route path="/upload-tags/*" element={<UploadTags />} />
            <Route path="/tags/*" element={<Tags />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/password/forgot" element={<ForgotPassword />} />
            <Route path="/password/reset" element={<ResetPassword />} />
            <Route path="/clients/*" element={<Clients />} />
            <Route path="/sectors/*" element={<Sectors />} />
            <Route path="/bars/*" element={<Bars />} />
            <Route path="/client-bars/*" element={<ClientBars />} />
            <Route path="/categories/*" element={<Categories />} />
            <Route path="/pages/:uuid" element={<Pages />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
